export default __webpack_public_path__ + "static/audio-cardio-5-g-e24b379d5c3d0309033147aea71f45f3.webp";